<div
  class="dialog-header flex align-items-center justify-content-between w-full"
>
  <div class="flex flex-column">
    <h2>Detalii Comandă</h2>
    <p-tag
      [value]="command.state"
      [severity]="getCommandStateSeverity($any(command.state))"
    ></p-tag>
  </div>
  <p-button
    mat-dialog-close
    size="small"
    icon="pi pi-times"
    severity="secondary"
    [rounded]="true"
    [text]="true"
  />
</div>

<mat-dialog-content>
  <div class="grid">
    <div class="col-12 md:col-12">
      <div class="card shadow-1 border-round p-4">
        <h3>Informații Generale</h3>
        <div class="flex flex-column gap-2">
          <div class="flex justify-content-between">
            <span class="font-bold">Tip Acțiune:</span>
            <span>{{ command.actionType }}</span>
          </div>
          <div class="flex justify-content-between">
            <span class="font-bold">Stare:</span>
            <p-tag
              [value]="command.state"
              [severity]="getCommandStateSeverity($any(command.state))"
            ></p-tag>
          </div>
          <div class="flex justify-content-between">
            <span class="font-bold">Executat de:</span>
            <span
              >{{ command.performedBy.name }} ({{
                command.performedBy.email
              }})</span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 md:col-12">
      <div class="card shadow-1 border-round p-4">
        <h3>Acțiune Ușă</h3>
        @if (command.doorAction) {
        <div class="flex flex-column gap-2">
          <div class="flex justify-content-between">
            <span class="font-bold">Box ID:</span>
            <span>{{ command.doorAction.uniqueBoxId }}</span>
          </div>
          <div class="flex flex-column gap-2 mt-3">
            <div class="flex justify-content-between">
              @let openedAt = command.doorAction.openDoor?.openedAt;
              <span class="font-bold">Deschis la:</span>
              <span>{{ openedAt ? formatDate(openedAt) : "-" }}</span>
            </div>
            <div class="flex justify-content-between">
              @let createdAt = command.doorAction.openDoor?.createdAt;
              <span class="font-bold">Creat la:</span>
              <span>{{ createdAt ? formatDate(createdAt) : "-" }}</span>
            </div>
            <div class="flex justify-content-between">
              @let updatedAt = command.doorAction.openDoor?.updatedAt;
              <span class="font-bold">Actualizat la:</span>
              <span>{{ updatedAt ? formatDate(updatedAt) : "-" }}</span>
            </div>
            <div class="flex justify-content-between">
              @let finishedAt = command.doorAction.openDoor?.finishedAt;
              <span class="font-bold">Finalizat la:</span>
              <span>{{
                finishedAt ? formatDate(finishedAt) : finishedAt
              }}</span>
            </div>
            <div class="flex justify-content-between">
              @let triggeredAt = command.doorAction.openDoor?.triggeredAt;
              <span class="font-bold">Declanșat la:</span>
              <span>{{ triggeredAt ? formatDate(triggeredAt) : "-" }}</span>
            </div>
            <div class="flex justify-content-between">
              <span class="font-bold">ID Procedură:</span>
              <span>{{ command.doorAction.openDoor?.procedureId }}</span>
            </div>
          </div>
        </div>
        } @else {
        <p>Nu există acțiune de ușă pentru această comandă.</p>
        }
      </div>
    </div>

    <div class="col-12">
      <div class="card shadow-1 border-round p-4">
        <h3>Metadata</h3>
        <p-table
          [value]="command.meta"
          styleClass="p-datatable-sm p-datatable-striped"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Cheie</th>
              <th>Valoare</th>
              <th>Creat la</th>
              <th>Actualizat la</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-meta>
            <tr>
              <td>{{ meta.key }}</td>
              <td>{{ meta.value }}</td>
              <td>{{ formatDate(meta.createdAt) }}</td>
              <td>{{ formatDate(meta.updatedAt) }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="4" class="text-center">
                Nu există metadata pentru această comandă.
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</mat-dialog-content>
